<script lang="ts">
  import { cn } from '@/lib/utils';
  import type { Tone } from './statFormat';
  import type { MaxActivity } from '../progressionApi';

  export let label: string;
  export let value: string;
  /** Colours the value and puts an arrow in front of it, for figures that are a change. */
  export let tone: Tone | null = null;
  export let title: string = '';
  /** For a "Max" figure: the activity it came from. The value itself becomes a link to it. */
  export let activity: MaxActivity | null = null;

  // The date is the athlete's own calendar day, so read it as text rather than as an instant.
  $: activityDate = activity?.date
    ? new Date(`${activity.date.slice(0, 10)}T12:00:00`).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })
    : '';
</script>

<!-- One figure in a card's single row: it never wraps, so the label and value have to be short. -->
<div class="flex flex-col min-w-0 whitespace-nowrap" {title}>
  <dt class="text-[11px] text-muted-foreground m-0">{label}</dt>
  <dd
    class={cn(
      'm-0 text-[15px] font-medium leading-tight tabular-nums',
      tone === 'up' && 'text-green-600',
      tone === 'down' && 'text-red-600'
    )}
  >
    {#if tone === 'up'}<span class="text-[9px]" aria-hidden="true">▲</span>{:else if tone === 'down'}<span class="text-[9px]" aria-hidden="true">▼</span>{/if}{#if activity?.url}
      <a
        href={activity.url}
        target="_blank"
        rel="noopener"
        class="text-inherit underline decoration-dotted decoration-1 underline-offset-2 hover:decoration-solid"
        title={activity.name ? `${activity.name} — ${activityDate}` : activityDate}
      >{value}</a>
    {:else}{value}{/if}
  </dd>
  <slot name="below" />
</div>
